import { __ } from '@wordpress/i18n';
import{useBlockProps, RichText} from "@wordpress/block-editor"


export default function Edit(blockProps){

    const { attributes, setAttributes, clientId} = blockProps;
    const { blockId, content} = attributes;



    return( 
        <section className="find-shop">
            <div className="shops-grid">
                <div className="shops-grid__content">
                    <div className="shops-title">
                    <RichText
                        { ...blockProps }
                        className='shops__title'
                        tagName="h3" 
                        value={ content } 
                        allowedFormats={ [ 'core/bold', 'core/italic' ] }  
                        onChange={ ( Newcontent ) => setAttributes( { content:Newcontent } ) } 
                    />
                    </div>
                    <div className="content-search-shops">
                    </div>
                </div>
            
                <div className="content-filtes-control">
                    <div className="content-search-shops">
                        <img src="https://pintuco.com.co/wp-content/themes/pintuco-v2/images/brocha.png"/>
                        <form id="filter" className="filter-search">
                            <div className="filter-search__form-group">
                                <select className="form-control deparmentos--filter" name="departamentfilter">  
                                    <option value="0" selected=""> Departamentos </option>
                                </select> 
                            </div> 
                            <div className="filter-search__form-group"> 
                                <select className="form-control ciudades--filter" name="ciudadfilter"> 
                                    <option value="" disabled="" selected=""> Ciudades </option> 									
                                </select> 
                            </div>						        
                        </form>
                    </div>
                </div>   
            </div>
            <div className="js-load-shops">
             </div>
        </section>
        )
}

